import React, { Component } from 'react';
import { Form, Input, Button, Checkbox, Typography, Row, Col, Card, FormInstance,Image } from 'antd';
import { UserOutlined, LockOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import config from "../config.js";

const { Title, Text, Link } = Typography;

// interface LoginFormValues {
//   email: string;
//   password: string;
//   remember: boolean;
// }

// interface SmartTrackLoginState {
//   loading: boolean;
// }

class SmartTrackLogin extends Component {
  //private formRef = React.createRef<FormInstance>();

   constructor(props) {
      super(props);
      //this.cookies = new Cookies();
        this.formRef = React.createRef();
    }


  render() {
    const { loading } = this.props.loading;

    const locationPins = [
      { top: '30%', left: '20%' },
      { top: '25%', left: '50%' },
      { top: '35%', left: '75%' },
      { top: '45%', left: '35%' },
    ];

    return (
      <Row style={{ minHeight: '100vh' }} className='loginWrapper'>
        {/* Left Side - Login Form */}
        <Col className='login-colLeft'
          xs={24}
          md={10}
          lg={8}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: '48px',
            background: '#fff',
          }}
        >
          {/* Logo */}
          
        <div className="logo">
                           <Image
                            preview={false}
                            src={`/logos/${config.project}-login.png`}
                            fallback={require(`../assets/images/trackeazy-logo.png`)}
                            alt="logo"
                          />
                        </div>

          {/* Login Form */}
          <Title level={3} >
            Log in to your Account
          </Title>

          <Form
            ref={this.formRef}
            name="login"
            initialValues={{ remember: true }}
            onFinish={this.props.onFinish}
            layout="vertical"
            size="large"
          >
            <Form.Item
                                name="userEmail"
                                label={this.props.context.translate(
                                  "_FLEET_COMPANY_USERDETAIL_USERNAME_"
                                )}
                                className="formfield username"
                                rules={[
                                  {
                                    required: true,
                                    message: this.props.context.translate(
                                      "_FLEET_COMPANY_USERNAME_PROVIDE_"
                                    ),
                                  },
                                ]}
                              >
                                <Input
                                  size="large"
                                  placeholder={this.props.context.translate("_USERNAME_")}
                                />
                              </Form.Item>
                              <Form.Item
                                className="formfield password"
                                label={this.props.context.translate(
                                  "_FLEET_COMPANY_USERDETAIL_PASSWORD_"
                                )}
                                name="password"
                                rules={[
                                  {
                                    required: true,
                                    message: this.props.context.translate(
                                      "_FLEET_COMPANY_PASSWORD_PROVIDE_"
                                    ),
                                  },
                                ]}
                              >
                                <Input.Password
                                  autoComplete="fail"
                                  style={{ padding: "0 0" }}
                                  type="password"
                                  placeholder={this.props.context.translate(
                                    "_FLEET_LOGIN_PASSWORDLBL_"
                                  )}
                                  size="large"
                                  iconRender={(visible) =>
                                    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                                  }
                                />
                              </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                   loading={this.props.loading}
                block
                
              >
                Sign In
              </Button>
            </Form.Item>
          </Form>
        </Col>

        {/* Right Side - Hero Image */}
        <Col xs={0} md={14} lg={16} style={{ position: 'relative' }}>
          <div
            
          >
            {/* Background Image Placeholder */}
            <div className='loginImg'
              style={{
          
                inset: 0,
                backgroundImage:`url(${require("../assets/images/" +
                  (config.loginBgImage
                    ? config.loginBgImage
                    : "new_login_bg.png"))})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                opacity: 0.9,
                borderRadius:'20px',
          
              }}
            />

            {/* Overlay Gradient */}
            <div
              
            />

            {/* Tracking Lines Animation Overlay */}
            <div
              
            />

            {/* Info Card */}
            <Card className='loginText'
              
            >
              <Text 
             
              >
                Smart Track Vehicle Tracking System ensures quick, secure access
                to your dashboard with real-time vehicle tracking Anytime, Anywhere.
              </Text>
            </Card>

            {/* Location Pins */}
            {locationPins.map((pos, index) => (
              <div
                key={index}
                style={{
                  position: 'absolute',
                  ...pos,
                  width: 40,
                  height: 40,
                  background: 'rgba(0, 180, 216, 0.8)',
                  borderRadius: '50% 50% 50% 0',
                  transform: 'rotate(-45deg)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 20px rgba(0, 180, 216, 0.5)',
                }}
              >
                <div
                  style={{
                    width: 20,
                    height: 20,
                    background: '#fff',
                    borderRadius: '50%',
                    transform: 'rotate(45deg)',
                  }}
                />
              </div>
            ))}
          </div>
        </Col>
      </Row>
    );
  }
}

export default SmartTrackLogin;
